/**
 =========================================================
 * Material Dashboard 2 React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// prop-types is a library for typechecking of props
import PropTypes from 'prop-types'

// @mui material components
import Grid from '@mui/material/Grid'

// Material Dashboard 2 React components
import MDBox from 'components/MDComponents/MDBox'
// import MDTypography from "components/MDTypography";

import PageLayout from '../../../LayoutContainers/PageLayout'

import ParticlesDiv from 'layouts/particles'

const CoverLayout = ({ children, fullscreen }) => {
  return (
    <PageLayout>
      <ParticlesDiv />
      <MDBox
        className="flex justify-center items-center w-full h-screen"
        px={1}
        mx="auto"
      >
        <MDBox style={{ width: '100%' }}>
          <Grid container spacing={1} justifyContent="center">
            {fullscreen ? (
              children
            ) : (
              <Grid item xs={12} sm={10} md={6} lg={5} xl={4}>
                {children}
              </Grid>
            )}
          </Grid>
        </MDBox>
      </MDBox>
    </PageLayout>
  )
}

// Setting default props for the CoverLayout
CoverLayout.defaultProps = {
  coverHeight: '35vh',
}

// Typechecking props for the CoverLayout
CoverLayout.propTypes = {
  coverHeight: PropTypes.string,
  // image: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
}

export default CoverLayout
